export default __webpack_public_path__ + "static/media/photo-1528731708534-816fe59f90cb.0255c234.jpg";